// LeloListPage.js - Fixed version
import React, { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";
import { Helmet } from "react-helmet-async";
import LeloFormList from "../../components/leloAdmin/LeloFormList";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";
import llacFav from "../../img/LLAC-favicon.ico";

const LeloListPage = () => {
  const navigate = useNavigate();
  const adminLeloContext = useContext(AdminLeloContext);
  const {
    getLeloEntries,
    Leloentries,
    clearSearchFilter,
    clearTableFilter,
    LeloListStatus,
    currentPage,
    pageSize,
    ActiveFilter,
    appliedFilters,
  } = adminLeloContext;

  const { inactive, active, signed } = LeloListStatus;
  const hasInitialLoadRef = useRef(false);

  // Initial load - set active filter and load default data
  useEffect(() => {
    if (!hasInitialLoadRef.current) {
      ActiveFilter(); // Set active filter as default
      getLeloEntries({
        status: "Active",
        page: 1,
        pageSize
      });
      hasInitialLoadRef.current = true;
    }
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      clearSearchFilter();
      clearTableFilter();
    };
  }, []);

  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>Secondary Enrollments</title> */}
        <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      <section id="interest-form-list-page">
        <div className="container">
          {/* <h2 className="text-center top-title">Secondary Enrollments</h2> */}
          <LeloFormList items={Leloentries} />
        </div>
      </section>
    </AdminLayout>
  );
};

export default LeloListPage;